module.exports = __webpack_public_path__ + "static/media/ranjit.6a832522.jpg";